import type { FaireProductEntity } from "../../entity_types/product";

export const p_utygkayjud: FaireProductEntity = {
  token: "p_utygkayjud",
  type: "product",
  name: "Italian Cookie Brittle – Dark Chocolate Peppermint SnackPack",
  brandToken: "b_4zl0felcyb",
  brandName: "Brooklyn Brittle",
  imageUrl:
    "https://cdn.faire.com/fastly/f39e86f4ff7d4b1fe9a021492f7b5069576217573c2640186e462551c8f735c0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1073880c0265a60e240c78eb7096333ad96a542db3535c535b85db4b0d35eb1.png",
    "https://cdn.faire.com/fastly/0932eb6044e51e642aec31d26230136d23f770ea9b85e2cce7b2dbefeff594f3.png",
    "https://cdn.faire.com/fastly/18bcf04eef32fec22482f7295c628535f9021617bebfd377015069fd882ad40b.jpeg",
    "https://cdn.faire.com/fastly/2109efd85bc43b40bdef6bbb14d263ca0b09eb7a0636981f14f8f51628f1bb49.png",
  ],
  priceDollars: 1.99,
  description:
    "A buttery, crunchy shortbread-style cookie brittle made with rich dark cacao powder and cool peppermint. Very crunchy and indulgent, each snack pack delivers an intense chocolate bite with a refreshing finish that feels distinctly winter-forward and seasonal.\n\n• Italian-style cookie brittle with a crunchy, satisfying texture\n• Rich dark chocolate flavor paired with cool peppermint\n• Made with real ingredients and no artificial preservatives\n• Egg-free recipe that fits certain dietary preferences\n• Individually wrapped snack packs designed for grab-and-go sales\n• 12 snack packs per box, with 2 cookie brittles per pack\n• 6-month shelf life that supports quick turnover and fresh rotation\n• Best suited for checkout counters, high-traffic areas, events, and gift baskets\n• Performs well in grocery stores, gourmet shops, hotels, airports, and specialty retail\n\n",
  tags: [],
  msrpDollars: 3.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:18.935Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
